import Axios from "axios";
import {
  SET_APPROVAL_STEP_NAMES,
  UNSET_APPROVAL_STEP_NAMES
} from "@/store/mutation-types";
import { getApprovalStepNames } from "@/store/api";

// initial state
const state = {
  getApprovalStepNames: [],
};

const getters = {
  getApprovalStepNames(state) {
    return state.getApprovalStepNames;
  },
};

const mutations = {
  [SET_APPROVAL_STEP_NAMES](state, data) {
    state.getApprovalStepNames = data;
  },
  [UNSET_APPROVAL_STEP_NAMES](state) {
    state.getApprovalStepNames = [];
  },
};

const actions = {
  getApprovalStepNames({ commit }) {
    return new Promise((resolve, reject) => {
      Axios.get(getApprovalStepNames)
        .then(function (response) {
          commit('SET_APPROVAL_STEP_NAMES', response.data.data);
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_APPROVAL_STEP_NAMES');
          reject(error);
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

